module.exports = __webpack_public_path__ + "img/gold-coin.bc56031d.svg";